<script>
export default {
  name: 'DownloadIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#368B57',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9964 7.5H10.6214V11.2L12.3464 9.475C12.4714 9.35 12.6298 9.29167 12.7881 9.29167C12.9464 9.29167 13.1048 9.35 13.2298 9.475C13.4714 9.71667 13.4714 10.1167 13.2298 10.3583L10.4381 13.15C10.1964 13.3917 9.79642 13.3917 9.55475 13.15L6.76309 10.3583C6.52142 10.1167 6.52142 9.71667 6.76309 9.475C7.00475 9.23333 7.40475 9.23333 7.64642 9.475L9.37142 11.2V7.5H5.99642C3.32975 7.5 1.66309 9.16667 1.66309 11.8333V13.9917C1.66309 16.6667 3.32975 18.3333 5.99642 18.3333H13.9881C16.6548 18.3333 18.3214 16.6667 18.3214 14V11.8333C18.3298 9.16667 16.6631 7.5 13.9964 7.5Z"
      :fill="color"
    />
    <path
      d="M10.6213 2.29163C10.6213 1.94996 10.338 1.66663 9.99634 1.66663C9.65467 1.66663 9.37134 1.94996 9.37134 2.29163V7.49996H10.6213V2.29163Z"
      :fill="color"
    />
  </svg>
</template>
